import { loggingFilter, createConsoleNotifier, browser } from '@doxo/willow-airbrake'

const { createAirbrakeClient } = browser
let airbrake

const appEnv = process.env.APPS_ENV || extractEnvIdFromURL()
if (appEnv === 'development' && process.env.NODE_ENV === 'development') {
  airbrake = createConsoleNotifier()
} else {
  airbrake = createAirbrakeClient({
    projectId: 523279,
    projectKey: '4aea96a4eebe3f6b44556f85df10b9a9',
    environment: appEnv
  })
  airbrake.addFilter(notice => {
    Object.assign(notice.context, {
      severity: navigator.onLine === false ? 'notice' : 'error'
    })
    if (navigator.onLine !== undefined) {
      notice.context.offline = !navigator.onLine
    }
    return notice
  })
  if (appEnv === 'development') {
    // When running in NODE_ENV === 'production' mode, it is useful to see notices in the console too, not only in Airbrake.
    // Note that loggingFilter is the last in the chain, meaning that if any preceding filter blocks the notice,
    // loggingFilter will not be called by Airbrake.
    airbrake.addFilter(loggingFilter)
  }
}

function extractEnvIdFromURL (url) {
  try {
    const regex = /^(https?:\/\/)?([^.]+)\.?([^.]+)?\.doxo\.com/i
    const match = (url || window.location.href).match(regex)
    if (!match) {
      return undefined
    }
    // match[0] is the entire match
    // match[1] is the protocol
    // match[2] is the first subdomain, i.e. app name
    // match[3] is the second subdomain, i.e. env id
    const envId = match[3]
    if (envId && !['alpha', 'beta', 'gamma', 'kappa', 'theta', 'demo', 'sigma', 'delta'].includes(envId.toLowerCase())) {
      return 'development'
    }
    return envId || 'prod'
  } catch (e) {
    /* ignore */
  }
}

// Important: must not be referenced prior to initializing Vue (i.e. in packs - e.g. packs/credit.js)
// to avoid circular references in notices sent to Airbrake.
export default airbrake



// WEBPACK FOOTER //
// ./frontend/src/helpers/airbrake.js